//
// c-popup.js
//

import {throttle} from 'throttle-debounce';
import {get_cookie, set_cookie} from '../cookies/crumblr';
import cookie_acceptance from '../cookies/cookie-acceptance';
import str_hash from '../helpers/str-hash';
import * as collection_listener from '../helpers/collection-listener';

const default_cookie_expiry_days = 182;

function popup(el) {
  let close_btns;
  let box;
  let opts;
  return init();

  // init
  // ------------------------------------

  function init() {
    opts = {
      unit: el.getAttribute('data-custom-display-unit'),
      value: el.getAttribute('data-custom-display-value'),
      expiry_timestamp: parseInt(el.getAttribute('data-expiry-date')),
      cookie_expiry_days: el.getAttribute('data-custom-cookie-expiry-days'),

      cb_scroll__throttled: null,
    };

    // if (popup_cookie_is_set() || is_expired() || disabled_via_query_parameter()) {
    //   return false;
    // }

    let initialized = false;

    // Trigger on scroll depth
    if (opts.unit === 'scroll_depth') {
      opts.value = parseInt(opts.value || 0);
      opts.cb_scroll__throttled = throttle(150, cb_scroll);
      window.addEventListener('scroll', cb_scroll__throttled);
      initialized = true;
    }

    // Trigger based on referrer
    else if (opts.unit === 'referrer') {
      if (document.referrer.includes(opts.value)) {
        setTimeout(show, 1000);
        initialized = true;
      }
    }

    // Trigger based on URL query parameter
    else if (opts.unit === 'query-param') {
      if (location.search.includes(opts.value)) {
        setTimeout(show, 1000);
        initialized = true;
      }
    }

    // Trigger based on URL hash
    else if (opts.unit === 'hash') {
      if (is_equal_to_hash()) {
        setTimeout(show, 1000);
        initialized = true;
      }
    }

    // Trigger after time
    else {
      opts.value = parseInt(opts.value || 3) * 1000;
      setTimeout(show, opts.value);
      initialized = true;
    }

    box = el.querySelector('.c-popup__box');
    close_btns = el.querySelectorAll('.js-popup__close');

    window.addEventListener('resize', focus_popup);
    collection_listener.add(close_btns, 'click', hide);

    return initialized;
  }

  function unbind() {
    collection_listener.remove(close_btns, 'click', hide);
    window.removeEventListener('resize', focus_popup);
  }

  function unbind_scroll() {
    if (opts.cb_scroll__throttled) {
      window.removeEventListener('scroll', opts.cb_scroll__throttled);
      opts.cb_scroll__throttled.cancel();
      opts.cb_scroll__throttled = null;
    }
  }

  function is_equal_to_hash() {
    return location.hash === `#${opts.value}`;
  }

  // scroll callback
  // ------------------------------------
  // - show popup if user has scrolled past threshold

  function cb_scroll() {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    if (offset > opts.value) {
      show();
    }
  }

  function focus_popup() {
    box.focus();
  }

  // Hide / show
  // ------------------------------------

  function hide() {
    el.classList.remove('s-popup-visible');
    unbind();
    // set_popup_cookie();

    // Clear the location hash if appropriate
    if (opts.unit === 'hash' && is_equal_to_hash()) {
      history.replaceState(null, null, location.pathname + location.search);
    }
  }

  function show() {
    el.classList.add('s-popup-visible');

    if (el.hasAttribute('data-custom-event-on-show')) {
      const event_name = el.getAttribute('data-custom-event-on-show');
      el.dispatchEvent(new CustomEvent(event_name));
    }

    unbind_scroll();
  }

  // Helpers
  // ------------------------------------

  function disabled_via_query_parameter() {
    return window.location.href.indexOf('?no-popups=') !== -1;
  }

  function popup_cookie_name() {
    return `popup-${Math.abs(str_hash(el.getAttribute('data-title')))}`;
  }

  function popup_cookie_is_set() {
    const c = get_cookie(popup_cookie_name());
    return c && c === 'Y';
  }

  function set_popup_cookie() {
    const cookie_expiry_days = parseInt(opts.cookie_expiry_days === null ? default_cookie_expiry_days : opts.cookie_expiry_days);
    set_cookie(popup_cookie_name(), 'Y', cookie_expiry_days);
  }

  function is_expired() {
    return opts.expiry_timestamp && opts.expiry_timestamp < Date.now() / 1000;
  }
}

// if (cookie_acceptance.functional.is_accepted()) {
const popups = document.querySelectorAll('.js-popup');

// Stop at the first popup on the page that inits successfully
for (let i = 0; i < popups.length; ++i) {
  const result = popup(popups[i]);
  if (result) {
    break;
  }
  // }
}
